// src/constants/navigationConfig.js
import {
    FaTachometerAlt,
    FaCalendarAlt,
    FaCalendar,
    FaHome,
    FaMoneyCheckAlt,
    FaListAlt, FaUserCircle, FaCog, FaMoneyBillWave, FaBook, FaImages
} from 'react-icons/fa';

const navigationConfig = [
    {
        title: 'Panel główny',
        navigate: '/',
        icon: FaTachometerAlt,
    },
    {
        title: 'Rezerwacje',
        navigate: '/reservation',
        icon: FaCalendarAlt,
    },
    {
        title: 'Kalendarz',
        navigate: '/calendar',
        icon: FaCalendar,
    },
    {
        title: 'Domki',
        navigate: '/houses',
        icon: FaHome,
    },
    {
        title: 'Cenniki',
        navigate: '/price-lists',
        icon: FaMoneyCheckAlt,
    },
    {
        title: 'Klienci',
        navigate: '/customer',
        icon: FaUserCircle,
    },
    {
        title: 'Płatności',
        navigate: '/payment-transaction',
        icon: FaMoneyBillWave,
    },
    {
        title: 'Dokumenty prawne',
        navigate: '/legal-documents',
        icon: FaBook,
    },
    {
        title: 'Zdjęcia globalne',
        navigate: '/common-images',
        icon: FaImages,
    },
    {
        title: 'Ustawienia',
        navigate: '/settings',
        icon: FaCog,
    },
];

export default navigationConfig;
